<template>
    <PopupRouterView :showLeftIcon="true" label="Purchase Request Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="purchaserequest"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="purchaseRequestInput">


        <b-card header="Purchase Request" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Purchase Request Number" :model="model.purchaseRequestNumber" />
						<app-input-combobox-autocomplete :options="partClassifications" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Part Classification" id="fieldset-part-classification" size="sm" :model.sync="model.partClassificationId"   :selected="model.partClassification != null ? model.partClassification.code : ''" @input="getPartClassifications" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPartClassification" />
						<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor" id="fieldset-vendor" size="sm" :model.sync="model.vendorId"   :selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedVendor" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-datepicker  id="fieldset-purchase-request-date" label-cols-lg="12"  label="Purchase Request Date" size="sm" :model.sync="model.purchaseRequestDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" />
						<app-input-datepicker  id="fieldset-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="model.deliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" />
						<app-input-textarea id="fieldset-remark" label-cols-lg="12"  label="Remark" label-for="input-remark" size="sm" :model.sync="model.remark"  @change="updateData" />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "PurchaseRequestDetail"
			:bordered="true" :items="purchaseRequestDetails" 
			:fields="fieldsPurchaseRequestDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByPurchaseRequestDetail" 
			:sort-desc.sync="sortDescPurchaseRequestDetail" small responsive	
			@editButtonMethod="editRowDataPurchaseRequestDetail"	
			@deleteButtonMethod="deleteRowDataPurchaseRequestDetail"	
			@showPopupAddMethod="addDataPurchaseRequestDetail()"	
			@showPopupUploadMethod="showPopupUploadPurchaseRequestDetail()"
			@downloadMethod="downloadPurchaseRequestDetail()"
			@addFromClipboardMethod="addFromClipboardPurchaseRequestDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardPurchaseRequestDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadPurchaseRequestDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPurchaseRequestDetailFilter = !isShowPurchaseRequestDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowPurchaseRequestDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Part Number">
					<v-select id="input-purchase-request-detail-part-table" append-to-body label="partNumber" :options="parts" :value="filterPurchaseRequestDetail.partId" :reduce="item => item.id" v-model="filterPurchaseRequestDetail.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty">
					<b-form-input id="input-purchase-request-detail-qty-table" v-model="filterPurchaseRequestDetail.qty" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( purchaseRequestDetailPageSize * (currentPurchaseRequestDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-purchase-request-detail-part-' + row.index" label-cols-lg="12" label="Part Number" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputPurchaseRequestDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(partName)="row">
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
			</template>
			<template v-slot:cell(qty)="row">
				<app-input-textbox :id="'input-purchase-request-detail-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty" :state="validateState('qty')" :errorMessage="getErrorMessage(errorMessage.qty, 'qty')"   @change="saveInputPurchaseRequestDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(uom)="row">
<app-label :id="'input-purchase-request-detail-uom-' + row.index" label-cols-lg="12" size="sm" label="Uom" :model="model.uom" />
			</template>

								
			<template v-slot:form-add-detail>
				<PurchaseRequestDetailInput 
					:model="modelPurchaseRequestDetail"
					:openPopup="isShowPopupPurchaseRequestDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPurchaseRequestDetail"/>
			</template>
			<template v-slot:upload-detail>
					<PurchaseRequestDetailUpload
					:openPopup="isShowPopupUploadPurchaseRequestDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPurchaseRequestDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPurchaseRequestDetailPage"
				:total-rows="totalPurchaseRequestDetailRow"
				:per-page="purchaseRequestDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PurchaseRequest from '@/models/PurchaseRequest/PurchaseRequest';
import PurchaseRequestList from '@/models/PurchaseRequest/PurchaseRequestList';
import PurchaseRequestFilter from '@/filters/PurchaseRequest/PurchaseRequestFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PartClassification from '@/models/PartClassification/PartClassification';
import PartClassificationFilter from '@/filters/PartClassification/PartClassificationFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import PurchaseRequestDetail from '@/models/PurchaseRequest/PurchaseRequestDetail';
import PurchaseRequestDetailFilter from '@/filters/PurchaseRequest/PurchaseRequestDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PurchaseRequestDetailInput from '@/views/PurchaseRequest/PurchaseRequestDetailInput';
import PurchaseRequestDetailUpload from '@/views/PurchaseRequest/PurchaseRequestDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputTextbox,
		PurchaseRequestDetailInput,PurchaseRequestDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsPurchaseRequestDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"part": { "class" : "th-part first-child", "label" : "Part Number", key: 'part', sortable: false}}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false}}, 
				{"qty": { "class" : "th-qty last-child", "label" : "Qty", key: 'qty', sortable: false}}, 
				{"uom": { "class" : "th-uom d-stack-none", "label" : "Uom", key: 'uom', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPurchaseRequestDetail : {},
			isShowPopupPurchaseRequestDetail : false,
			isShowPopupUploadPurchaseRequestDetail : false,
			filterPurchaseRequest : null,
			currentPurchaseRequestPage : 1,
			purchaseRequestPageSize: 10,
			sortByPurchaseRequest: '',
			sortDescPurchaseRequest: '',
			filterPurchaseRequestDetail : null,
			currentPurchaseRequestDetailPage : 1,
			purchaseRequestDetailPageSize: 10,
			sortByPurchaseRequestDetail: '',
			sortDescPurchaseRequestDetail: '',
			sortingByPurchaseRequestDetail: [],
			purchaseRequestDetails : [],
			purchaseRequestDetailId : '',
			totalPurchaseRequestDetailRow : 0,
			isShowPurchaseRequestDetailFilter: false,
			isDownloadPurchaseRequestDetail: false,
			parts: [],
			partClassifications: [],
			partClassifications: [],
			isPartClassificationComboLoading: false,
			vendors: [],
			vendors: [],
			isVendorComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPartClassificationComboLoading: false,
			isVendorComboLoading: false,
			isPartComboLoading: false,
			isPurchaseRequestComboLoading: false,
		}
	},
	methods : {
		getPurchaseRequest : async function(id) {
			this.isBusy = true;
			PurchaseRequest.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPurchaseRequest = true;
			this.filterPurchaseRequest.id = this.modelId;
			PurchaseRequest.downloadDataDetail(this, this.filterPurchaseRequest).then(result => {
				this.isDownloadPurchaseRequest = false;
			}).catch(error => { this.isDownloadPurchaseRequest = false; })
		},
		getPurchaseRequestDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPurchaseRequestDetail);
			if (this.modelId == null) return;
			filter.purchaseRequestId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByPurchaseRequestDetail != null) {
				this.sortingByPurchaseRequestDetail[this.sortByPurchaseRequestDetail] = this.sortDescPurchaseRequestDetail;
			}
			let currentPage = (this.currentPurchaseRequestDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPurchaseRequestDetailRow + 1;
				let page = Math.ceil(totalData/this.purchaseRequestDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.purchaseRequestDetailPageSize = 0;
			// disable paging end
			PurchaseRequestDetail.getList(this, filter, this.sortingByPurchaseRequestDetail, currentPage , this.purchaseRequestDetailPageSize).then(result => {
				this.currentPurchaseRequestDetailPage = currentPage + 1;
				this.purchaseRequestDetails = result.data;
				this.totalPurchaseRequestDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getPurchaseRequests : async function(input) {
			let filter = new PurchaseRequestFilter();
			if (input != undefined) {
				filter.PurchaseRequestNumber = input;
			}
			this.isPurchaseRequestComboLoading = true;
			PurchaseRequest.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseRequests = result.data
				}
				this.isPurchaseRequestComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getPurchaseRequests : async function(input) {
			let filter = new PurchaseRequestFilter();
			if (input != undefined) {
				filter.purchaseRequestNumber = input;
			}
			this.isPurchaseRequestComboLoading = true;
			PurchaseRequest.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseRequests = result.data
				}
				this.isPurchaseRequestComboLoading = false;
			})
			.catch(error => {});
		},
		getPartClassifications : async function(input) {
			let filter = new PartClassificationFilter();
			if (input != undefined) {
				filter.code = input;
			}
			PartClassification.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partClassifications = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPartClassification(item) {
			if(item == undefined || item == null) {
				this.model.partClassificationId = null;
				this.model.partClassification = null;
			} else {
				this.model.partClassificationId = item.id;
				this.model.partClassification = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendor(item) {
			if(item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.purchaseRequestInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PurchaseRequest.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'purchaserequestindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PurchaseRequest.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'purchaserequestindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PurchaseRequest.updateData(this, model, id)
					.catch((error) => {
						this.getPurchaseRequest(id);
					});
				}
			});
		},
		onHidden() {
			this.getPurchaseRequests();
		},
		addRowDataPurchaseRequestDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.purchaseRequestId =  this.modelId;
					PurchaseRequestDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPurchaseRequestDetails(true);
						this.isShowPopupPurchaseRequestDetail = false;
					})
				} else {
					model.purchaseRequestId =  this.modelId;
					PurchaseRequestDetail.createDataDetail(this, model)
					.then(result => {
						this.getPurchaseRequestDetails(true);
						this.isShowPopupPurchaseRequestDetail = false;
					})
				}
			}
		},
		async editRowDataPurchaseRequestDetail(id) {
			this.purchaseRequestDetailId = id;
			this.isShowPopupPurchaseRequestDetail = true; 
		},
		async deleteRowDataPurchaseRequestDetail(id) {
			PurchaseRequestDetail.deleteData(this, id).then(result => { this.getPurchaseRequestDetails(); });
		},
		async resetDataPurchaseRequestDetail() {
			this.purchaseRequestDetailId = "";
			this.isShowPopupPurchaseRequestDetail = true;
		},
		async addDataPurchaseRequestDetail() {
			PurchaseRequestDetail.createData(this, { purchaseRequestId: this.modelId })
			.then(result => {
				this.getPurchaseRequestDetails(true);
			})
		},
		async addFromClipboardPurchaseRequestDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, purchaseRequestId: this.modelId });
				});
				PurchaseRequestDetail.addFromClipboard(this, parts).then(result => { this.getPurchaseRequestDetails() });
			});
		},
		async replaceFromClipboardPurchaseRequestDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, purchaseRequestId: this.modelId });
				});
				PurchaseRequestDetail.replaceFromClipboard(this, parts).then(result => { this.getPurchaseRequestDetails() });
			});   
		},
		showPopupUploadPurchaseRequestDetail() {
			if(this.purchaseRequestDetails != null && this.purchaseRequestDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PurchaseRequestDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPurchaseRequestDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPurchaseRequestDetail = true;
			}
		},
		uploadDataPurchaseRequestDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPurchaseRequestDetail = false; 
		},
		downloadPurchaseRequestDetail(modalEvent) {
			this.isDownloadPurchaseRequestDetail = true;
			this.filterPurchaseRequestDetail.purchaseRequestId = this.modelId;
			PurchaseRequestDetail.downloadDataDetail(this, this.filterPurchaseRequestDetail).then(result => {
				this.isDownloadPurchaseRequestDetail = false;
			}).catch(error => { this.isDownloadPurchaseRequestDetail = false; })
		},
		saveInputPurchaseRequestDetail(item) {
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.purchaseRequests != null && this.purchaseRequests != undefined  && this.purchaseRequests.length > 0) {
				item.purchaseRequest = this.purchaseRequests.find(q => q.id == item.purchaseRequestId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PurchaseRequestDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPurchaseRequestDetail = false; 
			this.isShowPopupPurchaseRequestDetail = false; 
			if (modalType == 'PurchaseRequestDetail') {
				this.getPurchaseRequestDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowPurchaseRequestDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPurchaseRequest = new PurchaseRequestFilter();
		this.filterPurchaseRequestDetail = new PurchaseRequestDetailFilter();
		//this.getParts();
		//this.getPurchaseRequests();
		//this.getPartClassifications();
		//this.getVendors();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPurchaseRequest(id);
			} else {
				this.modelId = id;
				this.getPurchaseRequest(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByPurchaseRequestDetail : {
			handler: function() {
				this.getPurchaseRequestDetails();
			}
		},
		sortDescPurchaseRequestDetail: {
			handler: function() {
				this.getPurchaseRequestDetails();
			}
		},
		currentPurchaseRequestDetailPage: {
			handler: function() {
				this.getPurchaseRequestDetails();
			}
		},
		purchaseRequestDetailPageSize : {
			handler: function() {
				this.getPurchaseRequestDetails();
			}
		},
		filterPurchaseRequestDetail: {
			handler: function() {
				this.getPurchaseRequestDetails();
			},
			deep: true,
		},
	},
}
</script>
